export default __webpack_public_path__ + "static/blackcliff_agate-25fc010fb701adbef9eec5499764b39d.png";